import React, { useEffect, useState } from "react";
import ScrollToTop from "../ScrollToTop";
import AdminSidebar from "../../Component/AdminSidebar";
import B2BClientsTab from "../../components/B2B/B2BClientsTab";
import B2BSalesList from "../../components/B2B/B2BSalesList";
import B2BPaymentModal from "../../components/B2B/B2BPaymentModal";
import { loadB2BClients } from "../../data/b2bClients";
import { loadB2BSales, saveB2BSale } from "../../data/b2bSales";
import { loadCatalog } from "../../data/catalog";

const MyAccountB2B = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);
  const [activeTab, setActiveTab] = useState("sales");
  const [clients, setClients] = useState([]);
  const [sales, setSales] = useState([]);
  const [catalogProducts, setCatalogProducts] = useState([]);
  
  const [showPaymentModal, setShowPaymentModal] = useState(null); // holds sale object

  useEffect(() => {
    let isMounted = true;
    Promise.all([loadB2BClients(), loadB2BSales(), loadCatalog()]).then(([c, s, cat]) => {
      if (!isMounted) return;
      setClients(c);
      setSales(s);
      setCatalogProducts(cat);
      setLoaderStatus(false);
    });
    return () => { isMounted = false; };
  }, []);

  const handlePaymentConfirm = async (paymentData) => {
    if (!showPaymentModal) return;
    const updated = await saveB2BSale({
      ...showPaymentModal,
      status: "paid",
      paymentMethod: paymentData
    });
    setSales(sales.map(s => s.id === updated.id ? updated : s));
    setShowPaymentModal(null);
  };

  if (loaderStatus) {
    return (
      <div><ScrollToTop /><section><div className="container"><div className="row"><AdminSidebar activePath="/MyAccountB2B" /><div className="col-lg-9 col-md-8 col-12"><div className="p-6 p-lg-10"><div className="alert alert-light border mb-0">Chargement...</div></div></div></div></div></section></div>
    );
  }

  return (
    <div>
      <ScrollToTop />
      <section className="admin-section">
        <div className="container">
          <div className="row">
            <AdminSidebar activePath="/MyAccountB2B" />
            <div className="col-lg-9 col-md-8 col-12">
              <div className="p-6 p-lg-10">
                <div className="d-flex justify-content-between align-items-center mb-6 flex-wrap gap-2">
                  <div>
                    <h2 className="mb-1">Ventes B2B (Pro)</h2>
                    <p className="text-muted mb-0">Gérez vos devis, factures clients pro et bons de livraison.</p>
                  </div>
                </div>

                <div className="admin-tabs">
                  {[
                    { key: "sales", label: "Factures & Devis" },
                    { key: "clients", label: "Clients Pro (Restaurants)" }
                  ].map((tab) => (
                    <button key={tab.key} type="button" className={`admin-tab-btn${activeTab === tab.key ? " active" : ""}`} onClick={() => setActiveTab(tab.key)}>
                      {tab.label}
                    </button>
                  ))}
                </div>

                {activeTab === "clients" && (
                  <B2BClientsTab clients={clients} setClients={setClients} />
                )}

                {activeTab === "sales" && (
                  <B2BSalesList 
                    sales={sales} 
                    setSales={setSales} 
                    clients={clients} 
                    catalogProducts={catalogProducts}
                    onRequestPayment={(sale) => setShowPaymentModal(sale)} 
                  />
                )}

                {showPaymentModal && (
                  <B2BPaymentModal 
                    amount={showPaymentModal.totalTTC}
                    onConfirm={handlePaymentConfirm}
                    onClose={() => setShowPaymentModal(null)}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyAccountB2B;


